(function () {

    angular
        .module('smartertoolsApp')
        .controller('scheduledPaymentCtrl', ['$scope', 'invoices', scheduledPaymentCtrl]);

    function scheduledPaymentCtrl($scope, invoices) {
        const vm = this;
        vm.scheduledPayments = invoices.scheduledPayments;
        vm.dateOnServer = Date.now();

        // Functions
        vm.formattedCardNumber = formattedCardNumber;
        vm.isExpired = isExpired;

        // -----------------------------------------------

        function formattedCardNumber(item) {
            if (item.cardFirstTwo == '37')
                return `${item.cardFirstTwo}<span class=smaller-text>xx&nbsp;xxxxxx&nbsp;x</span>${item.cardLastFour}`;
            else
                return `${item.cardFirstTwo}<span class=smaller-text>xx&nbsp;xxxx&nbsp;xxxx&nbsp;</span>${item.cardLastFour}`;
        }

        function isExpired(expires) {
            return expires < Date.now();
        }
    }

})();